import { MenuItem } from "@mui/material";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getNomenclatures } from "../../../../actions/providedServices";
import { StyledProviderProvidedServiceForm } from "../../../styled/providers";
import FormikAutocomplete from "../../formik/formikAutocomplete";
import FormikSelect from "../../formik/formikSelect";
import FormikSwitch from "../../formik/formikSwitch";
import FormikTextField from "../../formik/formikTextField";
import CircularLoading from "../../loadingData/circularLoading";

const ServiceForm = ({ loading, editing }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const subnomenclatures = useSelector((state) => state.providedServices.subnomenclatures.data);
  const arts = useSelector((state) => state.arts.list);

  return (
    <>
      {!loading ? (
        <>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikSelect
              disabled={editing}
              name="art" label="Art*" variant="outlined" callBack={(value) => {
                if (value && value != values["art"]) {
                  dispatch(getNomenclatures(value));
                }
              }}>
              {arts.map((art) => (
                <MenuItem value={art.id} key={art.id}>
                  {art.nombre}
                </MenuItem>
              ))}
            </FormikSelect>
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikAutocomplete
              disabled={editing || !values["art"]}
              name="subnomenclador"
              label="Subnomenclador"
              options={subnomenclatures}
              getOptions={() => dispatch(getNomenclatures(values["art"]))}
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikTextField
              disabled={editing}
              name="prestacion"
              label="Prestacion*"
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikTextField
              name="nombre"
              label="Nombre*"
              disabled={editing}
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikTextField
              name="descripcion"
              label="Descripción*"
              disabled={editing}
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikSwitch
              name="habilitada"
              label="Habilitada"
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
        </>
      ) : (
        <CircularLoading />
      )}
    </>
  )
}

export default ServiceForm;